// extracted by mini-css-extract-plugin
export default {"icon":"OrderCreator_icon__o+Ega","person":"OrderCreator_person__V64MU","date":"OrderCreator_date__cChyZ","owner":"OrderCreator_owner__-IfT+"};